import { Box, Paper, Typography } from "@mui/material";
import React, { FC } from "react";

const DataGridGeneralTextCell: FC<{ text: string }> = ({ text }) => {
  return (
    <Paper>
      <Box m={1}>
        <Typography variant="body2">{text}</Typography>
      </Box>
    </Paper>
  );
};

export default DataGridGeneralTextCell;
